import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {createFrom, EventService} from '@spartacus/core';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {isPlatformBrowser} from '@angular/common';
import {ConfiguratorPageEvent} from './configurator-page-event';
import {filter, map} from 'rxjs/operators';
import {NavigationEvent} from '@spartacus/storefront';
import {Observable} from 'rxjs';

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class ConfiguratorPageEventService {
  constructor(@Inject(PLATFORM_ID) public platformId: string, protected event: EventService) {
    this.register();
  }

  protected register(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.event.register(ConfiguratorPageEvent, this.buildConfiguratorPageEvent());
  }

  protected buildConfiguratorPageEvent(): Observable<ConfiguratorPageEvent> {
    return this.event.get(NavigationEvent).pipe(
      untilDestroyed(this),
      filter((navigationEvent) => navigationEvent.semanticRoute === 'configurator'),
      map((navigationEvent) =>
        createFrom(ConfiguratorPageEvent, {
          navigation: navigationEvent,
        })
      )
    );
  }
}
